//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import borderImg from '@/assets/borderImg.png';
import titleicon from '@/assets/titleicon.png';
export default {
  data: function data() {
    return {
      borderImg: borderImg,
      titleicon: titleicon
    };
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  methods: {}
};